import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { FileText, FileDown, AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface ReviewTranscriptTabProps {
  data: any;
}

export function ReviewTranscriptTab({ data }: ReviewTranscriptTabProps) {
  if (!data.has_transcript) {
    return (
      <Card className="p-12 text-center">
        <FileText className="h-12 w-12 mx-auto mb-3 text-muted-foreground/50" />
        <p className="text-muted-foreground">No transcript recorded for this meeting</p>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <Alert>
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          The transcript provides a complete record of the meeting discussion. 
          It will be attached to the final minutes document.
        </AlertDescription>
      </Alert>

      {data.transcript_file_url && (
        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-semibold mb-2">Transcript File</h3>
              <p className="text-sm text-muted-foreground">
                External transcript file is available for download
              </p>
            </div>
            <Button
              variant="outline"
              onClick={() => window.open(data.transcript_file_url, "_blank")}
            >
              <FileDown className="h-4 w-4 mr-2" />
              Download File
            </Button>
          </div>
        </Card>
      )}

      {data.transcript_text && (
        <Card className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold">Transcript Text</h3>
            <Badge variant="outline">
              {data.transcript_text.length} characters
            </Badge>
          </div>
          
          <div className="bg-muted/50 rounded-lg p-4 max-h-[600px] overflow-y-auto">
            <pre className="text-sm whitespace-pre-wrap font-mono">
              {data.transcript_text}
            </pre>
          </div>
        </Card>
      )}
    </div>
  );
}
